module.exports = __webpack_public_path__ + "static/C2021_IEEEAero_abs-e8ae7fff6512b94df5fa350d4b19f5f8.gif";